<template>
  <portal target-el="#modal-portal">
    <v-layout row justify-center>
      <v-dialog
        v-model="versionModalVisible"
        persistent
        max-width="432px"
        attach="#modal-portal"
        hide-overlay
      >
        <v-card class="mx-auto">
          <v-toolbar dark color="primary" height="45">
            <v-toolbar-title>Star {{ applicationVersion }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn small icon color="primary" @click="close"><v-icon>close</v-icon></v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-tabs centered light icons-and-text>
              <v-tab :href="'#tab-info'">
                About
                <img src="/favicon.png" height="24px" />
              </v-tab>
              <v-tab :href="'#tab-reportBug'">
                Report a bug
                <v-icon>bug_report</v-icon>
              </v-tab>
              <v-tabs-items>
                <v-tab-item :value="'tab-info'">
                  <v-card>
                    <v-container fluid grid-list-sm class="py-2">
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-text-field
                            v-model="applicationOrigin"
                            label="Origin"
                            disabled
                          ></v-text-field>
                          <v-text-field
                            v-model="applicationRevision"
                            label="Revision"
                            disabled
                          ></v-text-field>
                          <v-text-field
                            v-model="applicationVersion"
                            label="Version"
                            disabled
                          ></v-text-field>
                          <v-text-field
                            v-model="applicationConfiguration"
                            label="Configuration"
                            disabled
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-tab-item>
                <v-tab-item :value="'tab-reportBug'">
                  <v-form @submit.prevent="reportBug" ref="form">
                    <v-card>
                      <v-container fluid grid-list-sm class="py-2">
                        <v-select
                          :items="sendToData"
                          v-model="sendTo"
                          label="To"
                          item-text="name"
                          item-value="mail"
                        ></v-select>
                        <v-text-field v-model="sendCc" label="CC:"></v-text-field>
                        <v-textarea
                          v-model="bugComments"
                          label="Comments"
                          counter="256"
                        ></v-textarea>
                        <v-switch v-model="sendScreenshot" label="Send screenshot" />
                        <input type="file" id="attachFiles" name="attachFiles" multiple="true" />
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn type="submit" color="blue primary" :disabled="sending">
                            <v-progress-circular indeterminate v-if="sending" />
                            Send
                          </v-btn>
                        </v-card-actions>
                      </v-container>
                    </v-card>
                  </v-form>
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>
            <v-container grid-list-md style="padding:3px;margin:2px"> </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </portal>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from 'axios'
import notification from '@/helpers/notification'

export default {
  name: 'versionInfo',
  props: {
    versionModalVisible: {type: Boolean, default: false},
  },
  mounted() {
    this.getClientData()
  },
  data() {
    return {
      sendTo: 'finmetrix@visionap.com',
      sendToData: [{name: 'Support', mail: 'finmetrix@visionap.com'}],
      sendCc: '',
      bugComments: '',
      sendScreenshot: true,
      sending: false,
    }
  },
  computed: {
    ...mapGetters({
      clientId: 'authentication/selectedClientId',
      currentUsername: 'authentication/currentUsername',
      applicationVersion: 'app/applicationVersion',
      applicationOrigin: 'app/applicationOrigin',
      applicationRevision: 'app/applicationRevision',
      applicationConfiguration: 'app/applicationConfiguration',
    }),
  },
  methods: {
    async getClientData() {
      const req = await axios
        .get('/api/config/client/getClient', {
          params: {
            clientId: 0,
            t: new Date().getTime(),
          },
        })
        .catch(() => notification('Error ', 'error'))
      let data = req.data
      this.sendCc = data.email
    },
    close() {
      this.$emit('close')
    },
    async getScreenshot() {
      const root = await kendo.drawing.drawDOM(kendo.jQuery('#app'))
      const data = await kendo.drawing.exportImage(root)
      return this.dataURItoBlob(data)
    },
    dataURItoBlob(dataURI) {
      const binary = atob(dataURI.split(',')[1])
      const array = []
      for (var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i))
      }

      return new Blob([new Uint8Array(array)], {type: 'image/png'})
    },
    async reportBug(e) {
      this.sending = true
      const currentClient = kendo
        .jQuery('.clientSelector')
        .find('input')
        .getKendoDropDownList()
        .text()

      const authenticationFile = new File(
        JSON.stringify(this.$store.state.authentication, null, 4).split('\n'),
        'authentication.store.state.json',
        {type: 'application/json'},
      )

      const applicationFile = new File(
        JSON.stringify(this.$store.state.app, null, 4).split('\n'),
        'application.store.state.json',
        {type: 'application/json'},
      )

      let formData = new FormData(e.target)
      formData.append('ApplicationOrigin', this.applicationOrigin)
      formData.append('ApplicationRevision', this.applicationRevision)
      formData.append('ApplicationVersion', this.applicationVersion)
      formData.append('CurrentUsername', this.currentUsername)
      formData.append('CurrentClientId', this.clientId)
      formData.append('CurrentClient', currentClient)
      formData.append('CurrentUrl', location.href)
      formData.append('SendTo', this.sendTo)
      formData.append('SendCc', this.sendCc)
      formData.append('SendComments', this.bugComments)
      formData.append('AuthenticationFile', authenticationFile, 'authentication.store.state.json')
      formData.append('ApplicationFile', applicationFile, 'application.store.state.json')

      if (this.sendScreenshot) {
        const screenshot = await this.getScreenshot()
        formData.append('Screenshot', screenshot, 'screenshot.png')
      }

      const response = await axios({
        url: '/api/VersionInfo/reportBug',
        method: 'post',
        data: formData,
        headers: {'Content-Type': 'multipart/form-data'},
      }).catch(() => {
        notification('Some error', 'error')
        this.sending = false
      })

      if (response.status == 200) {
        notification('Bug reported.')
      }

      this.bugComments = ''
      this.sending = false
      this.$emit('close')
    },
  },
  watch: {
    versionModalVisible(newValue) {
      if (newValue) {
        this.getClientData()
        this.bugComments = ''
        this.sendScreenshot = true
        this.sending = false
      }
    },
  },
}
</script>
